import { render, staticRenderFns } from "./ExistingArticles.vue?vue&type=template&id=18835a2a&scoped=true&"
import script from "./ExistingArticles.vue?vue&type=script&lang=js&"
export * from "./ExistingArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18835a2a",
  null
  
)

export default component.exports